import {
  CloseIconButton,
  DrawerHeader,
  DrawerTitle,
  StyledDrawer,
} from "./styles"
import { Transaction } from "../../models/transactions.model"
import CloseIcon from "@mui/icons-material/Close"
import { useState } from "react"
import { allowedCategorisationRoles } from "../../constants/data"
import { selectLogin } from "../../slices/loginSlice"
import { useAppSelector } from "../../app/hooks"
import { Box, Tab, Tabs } from "@mui/material"
import TransactionInfo from "./TransactionInfo"
import TransactionCategorySelector from "./TransactionCategorySelector"
import { selectTransactions } from "../../slices/transactionsSlice"

type TransactionDetailProps = {
  open: boolean
  onClose: () => void
  transactionData: Transaction
  fetchTransaction?: () => void
}

const TransactionDetail = ({
  open,
  onClose,
  transactionData,
  fetchTransaction,
}: TransactionDetailProps) => {
  const [activeTab, setActiveTab] = useState("details")
  const { role } = useAppSelector(selectLogin)
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue)
  }

  const { category } = useAppSelector(selectTransactions)

  return (
    <StyledDrawer open={open} onClose={onClose} anchor="right">
      <DrawerHeader>
        <DrawerTitle>Transaction Details</DrawerTitle>
        <CloseIconButton onClick={onClose}>
          <CloseIcon />
        </CloseIconButton>
      </DrawerHeader>

      <Tabs value={activeTab} onChange={handleChange}>
        <Tab label="Details" value="details" />
        {allowedCategorisationRoles.includes(role) && (
          <Tab label="Categorisation" value="categorisation" />
        )}
      </Tabs>
      {
        <TabPanel value={activeTab} index="details">
          <TransactionInfo transactionData={transactionData} />
        </TabPanel>
      }
      <TabPanel value={activeTab} index="categorisation">
        {activeTab === "categorisation" && (
          <TransactionCategorySelector
            category={category}
            updateCategory
            onClose={onClose}
            fetchTransaction={fetchTransaction}
          />
        )}
      </TabPanel>
    </StyledDrawer>
  )
}

type TabPanelProps = {
  children: React.ReactNode
  value: string
  index: string
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <Box hidden={value !== index} sx={{ height: "100%" }}>
      {children}
    </Box>
  )
}

export default TransactionDetail
